<template>
  <div class="links-handler">
    <custom-chips-group
      class="chips-group_extended"
      title="Enlace de Pantalla (URL):"
      :selected-items="value"
      :no-wrap="true"
      no-background
      object-text="name"
      :on-item-deleted="unSelectItem"
    />
    <validation-observer ref="linkInput" disabled>
      <div v-if="!readonly" class="add-section">
        <validation-provider
          v-slot="{ errors }"
          class="w-95 mx-0"
          rules="required"
        >
          <custom-input
            v-model="link"
            :error="errors[0]"
            custom-error-msg="El enlace es requerido."
          />
        </validation-provider>
        <action-button
          i="fal fa-plus-circle"
          class="extended_btn"
          @click="addLink"
        />
      </div>
    </validation-observer>
    <error v-if="error && error.length" variant="no-border" :message="error" />
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomChipsGroup from 'CustomChipsGroup';
import ActionButton from 'ActionButton';
import Error from 'custom-error';

export default {
  name: 'LinksHandler',
  components: { CustomChipsGroup, CustomInput, ActionButton, Error },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    error: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ link: null }),
  methods: {
    async addLink() {
      const valid = await this.$refs.linkInput.validate();
      if (!valid) return;
      this.value.push(this.link);
      this.link = null;
      await this.$refs.linkInput.reset();
    },
    unSelectItem(item) {
      const index = this.value.indexOf(item);
      if (index !== -1) {
        this.value.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.links-handler {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  margin-bottom: 1rem;
  background: map-get($colors, 'secondary-3');
  border-radius: 0.25rem;
  .chips-group_extended {
    margin-top: -0.5rem;
    ::v-deep {
      .chips-container {
        margin: 0 !important;
        padding-top: 0 !important;
        p.bold {
          font-weight: normal !important;
        }
      }
    }
  }
  .add-section {
    display: flex;
    align-items: flex-start;
    ::v-deep .extended_btn {
      margin-left: 0.5rem;
      i.fal {
        font-size: 1.5rem;
        color: map-get($colors, 'green');
      }
    }
  }
}
</style>
